import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getGlobalAiExchangeAgentAnalytics = {
  name: "getGlobalAiExchangeAgentAnalytics" as const,
  input: z.object({
    teamIds: z
      .array(zExt.objectId())
      .optional()
      .describe("Optional filter by specific team IDs"),
    analysisDate: z
      .string()
      .optional()
      .describe(
        "Custom date to use as cutoff for before/after analysis (ISO string). If not provided, uses AI exchange agent go-live date for each team.",
      ),
  }),
  output: z.object({
    globalMetrics: z.object({
      totalAiExchangeInteractions: z
        .number()
        .describe("Total AI exchange agent interactions across all teams"),
      averageExchangeRateLift: z
        .number()
        .describe(
          "Average exchange rate lift across all teams (relative change, e.g., 6% from 3% to 9%)",
        ),
      averageExchangeRateAbsolutePercentChange: z
        .number()
        .describe(
          "Average exchange rate absolute percent change across all teams (e.g., 300% from 3% to 9%)",
        ),
      totalAdditionalRevenueGenerated: z
        .number()
        .describe("Total additional revenue generated across all teams"),
      teamsWithAiExchangeAgent: z
        .number()
        .describe("Number of teams that have AI exchange agent enabled"),
      averageExchangeRateBeforeDate: z
        .number()
        .describe(
          "Average exchange rate across all teams before the analysis date",
        ),
      averageExchangeRateAfterDate: z
        .number()
        .describe(
          "Average exchange rate across all teams after the analysis date",
        ),
      totalReturnsBeforeDate: z
        .number()
        .describe(
          "Total number of returns across all teams before the analysis date",
        ),
      totalReturnsAfterDate: z
        .number()
        .describe(
          "Total number of returns across all teams after the analysis date",
        ),
    }),
    teamBreakdown: z
      .array(
        z.object({
          teamId: zExt.objectId(),
          teamName: z.string(),
          aiExchangeInteractions: z.number(),
          exchangeRateLift: z
            .number()
            .describe(
              "Exchange rate lift (relative change, e.g., 6% from 3% to 9%)",
            ),
          exchangeRateAbsolutePercentChange: z
            .number()
            .describe(
              "Exchange rate absolute percent change (e.g., 300% from 3% to 9%)",
            ),
          additionalRevenueGenerated: z.number(),
          aiExchangeAgentGoLiveDate: z.string().nullable(),
          exchangeRateBeforeDate: z
            .number()
            .describe("Exchange rate before the analysis date"),
          exchangeRateAfterDate: z
            .number()
            .describe("Exchange rate after the analysis date"),
          totalReturnsBeforeDate: z
            .number()
            .describe("Total returns before the analysis date"),
          totalReturnsAfterDate: z
            .number()
            .describe("Total returns after the analysis date"),
          analysisDate: z
            .string()
            .describe("The date used for before/after analysis"),
        }),
      )
      .describe("Per-team breakdown of AI exchange agent metrics"),
  }),
};
